"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AddAnotherLineState_1 = require("./AddAnotherLineState");
var styles = require("./AddAnotherLine.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var ReportingService_1 = require("../../../api/ReportingService");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var Utils = require("../../../utils/UtilityFunctions");
var components_1 = require("@idp/duc/components");
var cartUtils = require("../../../utils/CartUtilFunctions");
var add_newline_modal_1 = require("@sales/add-newline-modal");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var UtilityFunctions_1 = require("../../../utils/UtilityFunctions");
var AddAnotherLine = /** @class */ (function (_super) {
    __extends(AddAnotherLine, _super);
    function AddAnotherLine(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new AddAnotherLineState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.toggleAddaLineSection = _this.toggleAddaLineSection.bind(_this);
        _this.addALineselection = _this.addALineselection.bind(_this);
        _this.displayFNModal = _this.displayFNModal.bind(_this);
        _this.hideAddALineModal = _this.hideAddALineModal.bind(_this);
        return _this;
    }
    AddAnotherLine.prototype.componentDidMount = function () {
        if (cartUtils.isMobileUserAgent() || Utils.isMobile()) {
            this.setState({ addAlineToggleOpen: false });
        }
        else {
            this.setState({ addAlineToggleOpen: true });
        }
    };
    AddAnotherLine.prototype.render = function () {
        var _this = this;
        var CMSData = this.props.data.CMSData;
        var addAOwnDeviceURL = ReportingService_1.PageUrls.BYOD_PRODUCT_DETAILS_PAGE;
        var addNewDeviceURL = ReportingService_1.PageUrls.BUYFLOW_PRODUCT_LIST_PAGE;
        var isCarribeanUser = cartUtils.isFNCarribeanUser();
        return (React.createElement("section", null,
            React.createElement("div", null,
                React.createElement("div", { className: styles.addALinePanelBenefitHeading },
                    React.createElement("div", { className: styles.title },
                        React.createElement("h3", { className: styles.titleText },
                            " ",
                            CMSData.aALTittle,
                            " ")),
                    React.createElement("div", null,
                        React.createElement(components_1.Link, { "aria-label": this.state.addAlineToggleOpen ? 'Collapse Add Another Line Panel' : 'Expand Trade-in panel', kind: "withPrependIcon", testId: utils_1.default('Cart', 'getAddaLine'), 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { return _this.toggleAddaLineSection(); }, icon: this.state.addAlineToggleOpen ?
                                React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.UP }) :
                                React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.DOWN }) }))),
                React.createElement("div", { style: { clear: 'both' } })),
            React.createElement("div", { className: styles.addALinePanelBenefit }, CMSData.aALBenefit),
            this.state.addAlineToggleOpen &&
                React.createElement("div", null,
                    React.createElement("div", { className: styles.addALinePanelLinks },
                        React.createElement("div", { className: styles.alignmentBox },
                            React.createElement(components_1.CardShell, { type: "radio", isChecked: this.state.deviceOptionSelected ? true : false, tabIndex: 0, withSelectedBg: true, 
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick: function () { return _this.addALineselection(addNewDeviceURL); } },
                                React.createElement("div", { className: styles.boxContent },
                                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Add A Line'), data: { isDecodingRequired: false, text: CMSData.aALSelectDeviceButton } }))),
                            !cartUtils.isFNIntentPresent() &&
                                React.createElement(components_1.CardShell, { type: "radio", isChecked: this.state.ownDeviceOptionSelected ? true : false, tabIndex: 0, withSelectedBg: true, 
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onClick: function () { return _this.addALineselection(addAOwnDeviceURL); } },
                                    React.createElement("div", { className: [styles.boxContent, styles.boxWidth].join(' ') },
                                        React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Add A Line'), data: { isDecodingRequired: false, text: CMSData.aALBringYourDeviceButton } }))),
                            cartUtils.isFNIntentPresent() &&
                                React.createElement(components_1.CardShell, { type: "radio", isChecked: this.state.noThanksSelected ? true : false, tabIndex: 0, withSelectedBg: true, 
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onClick: function () { return _this.addALineselection('#'); } },
                                    React.createElement("div", { className: [styles.boxContent, styles.boxWidth].join(' ') },
                                        React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Add A Line'), data: { isDecodingRequired: false, text: CMSData.aALNotInterestedButton } })))),
                        !cartUtils.isFNIntentPresent() &&
                            React.createElement(components_1.CardShell, { type: "radio", isChecked: this.state.noThanksSelected ? true : false, tabIndex: 0, withSelectedBg: true, 
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick: function () { return _this.addALineselection('#'); } },
                                React.createElement("div", { className: [styles.boxContent, styles.boxWidth].join(' ') },
                                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Add A Line'), data: { isDecodingRequired: false, text: CMSData.aALNotInterestedButton } }))))),
            this.displayFNModal(isCarribeanUser)));
    };
    AddAnotherLine.prototype.addALineselection = function (url) {
        if (cartUtils.isFNIntentPresent() && url === ReportingService_1.PageUrls.BUYFLOW_PRODUCT_LIST_PAGE) {
            this.setState({ isFNModalOpen: true });
        }
        else {
            cartUtils.getRedirectionUrl('', url, 'Add another line');
            if (url === ReportingService_1.PageUrls.BYOD_PRODUCT_DETAILS_PAGE) {
                this.setState({ ownDeviceOptionSelected: true, deviceOptionSelected: false, noThanksSelected: false });
            }
            else if (url === ReportingService_1.PageUrls.BUYFLOW_PRODUCT_LIST_PAGE) {
                this.setState({ deviceOptionSelected: true, ownDeviceOptionSelected: false, noThanksSelected: false });
            }
            else if (url === '#') {
                this.setState({ addAlineToggleOpen: false, deviceOptionSelected: false,
                    noThanksSelected: true, ownDeviceOptionSelected: false });
            }
            else {
                this.setState({ deviceOptionSelected: false, ownDeviceOptionSelected: false, noThanksSelected: false });
            }
        }
    };
    AddAnotherLine.prototype.toggleAddaLineSection = function () {
        var _this = this;
        this.setState({ addAlineToggleOpen: !this.state.addAlineToggleOpen }, function () {
            _this.reportingService.fireLinkClickEvent(_this.state.addAlineToggleOpen ? 'promo toggle open' : 'promo toggle close', CartUtilFunctions_1.getLinkClickBasekUrl());
        });
    };
    AddAnotherLine.prototype.displayFNModal = function (fnCaribbean) {
        var _this = this;
        document.querySelector('html').style.overflowY = 'scroll';
        var campaignId = UtilityFunctions_1.getCampaignSessionId();
        var redirectUrls = {
            hotspot: '/buy/connected-devices-and-more',
            smartphone: '/buy/phones',
            tablet: '/buy/tablets',
            wearable: '/buy/wearables',
        };
        return (React.createElement(ui_components_1.Modal, { testId: "Modal_AAL_FN", options: { className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                show: this.state.isFNModalOpen, showClose: true }, events: { onClose: function () { return _this.hideAddALineModal(false); } }, accessibilityText: "_AAL_Modal_FN" },
            React.createElement(add_newline_modal_1.AddNewLineModal, { flowType: add_newline_modal_1.FlowTypes.NEW, heading: this.props.data.CMSData.aalModalHeading, selectMemberText: this.props.data.CMSData.aalModalMemberText, tab1Heading: this.props.data.CMSData.aalTab1Heading, tab2Heading: this.props.data.CMSData.aalTab2Heading, tab1Copy: this.props.data.CMSData.aalTab1Copy, tab2Copy: this.props.data.CMSData.aalTab2Copy, submitBtnText: this.props.data.CMSData.aalSubmitBtnText, submitBtnRedirectUrls: redirectUrls, campaignIdHeader: campaignId, suppressFamilyMemberBtn: fnCaribbean })));
    };
    AddAnotherLine.prototype.hideAddALineModal = function (bool) {
        document.querySelector('html').style.overflow = 'hidden';
        this.setState({ isFNModalOpen: bool });
    };
    return AddAnotherLine;
}(React.Component));
exports.default = AddAnotherLine;
//# sourceMappingURL=AddAnotherLine.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/AddALine/AddAnotherLine.js
// module id = 2296
// module chunks = 8